import { createRouter, createWebHistory } from 'vue-router';

import { useRouteStore } from '@/stores/tracking/routeStore';
import useBeforeEach from '@/composables/router/useBeforeEach';
import handleDirectVisit from '@/router/middleware/handleDirectVisit';
import { logPageView } from '@/composables/tracking/useGoogleAnalyticTracking';
import { trackIdentityStepTransition } from '@/composables/tracking/useIdentityStepTracking';
import { initPapiTransitCheckoutForRoute, registerEntryPointResolver } from '@/composables/tracking/useConversionTracking';
import { resolveCheckoutEntryPoint } from '@/router/checkoutEntryPoints';
import { useTrackingStore } from '@/stores/tracking/trackingStore';
import IdentityRoutes from './identity';
import NftRoutes from './nft';
import PrimaryRoutes from './primary';
import DebugRoutes from './debug';

let beforeEachHandlers = null;

const getBeforeEachHandlers = () => {
  if (!beforeEachHandlers) {
    beforeEachHandlers = useBeforeEach();
  }
  return beforeEachHandlers;
};

const allRoutes = [...PrimaryRoutes, ...IdentityRoutes, ...NftRoutes];

if (import.meta.env.VITE_ENV !== 'production') {
  allRoutes.push(...DebugRoutes);
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: allRoutes,
});

// Let the tracking layer attribute the funnel-integrity fallback from the route.
registerEntryPointResolver(() => resolveCheckoutEntryPoint(router.currentRoute.value));

router.beforeEach((to, from, next) => {
  const {
    handleSuccessModal,
    handleIdentityKycPathings,
    resetLoadingButtonState,
  } = getBeforeEachHandlers();
  handleSuccessModal(to, from);
  handleIdentityKycPathings(to, from);
  trackIdentityStepTransition(to, from);
  resetLoadingButtonState();
  initPapiTransitCheckoutForRoute(to);
  next();
});

router.afterEach((to, from) => {
  const routeHistory = useRouteStore();
  routeHistory.push(to);

  if (to.name === from.name) { return; }
  if (to.name === 'order' && from.name === 'order-recovery') {
    handleDirectVisit();
  }

  logPageView(to);
  const trackingStore = useTrackingStore();
  trackingStore.recordIdentifiers();

  getBeforeEachHandlers().resetLoadingButtonState();
  // if (to.name === from.name) { }
  // sendTrackerEvent();
});

export default router;
